export default function getResource(label, vars = []) {
    const resources = {
        title: 'Économisez sur votre achat',
        creditCardTitle: 'Récompenses Carte de crédit',
        creditCardPrimaryText: `Jusqu’à ${vars[0]} $`,
        creditCardSecondaryText: 'disponible',
        creditCardButtonText: 'Appliquer dans le panier',
        creditCardLinkText: 'En savoir plus',
        rougeRewardsTitle: 'Récompenses Rouge',
        rougeRewardsPrimaryText: `${vars[0]} de réduction`,
        rougeRewardsSecondaryText: 'disponible',
        rougeRewardsExpiresText: `Expires ${vars[0]}`,
        rougeRewardsButtonText: 'Appliquer',
        rougeRewardsLinkText: 'En savoir plus',
        biCashTitle: 'Dollars Beauty Insider',
        biCashPrimaryText: `Profitez de ${vars[0]} $ de réduction`,
        biCashSecondaryText: 'disponible',
        biCashButtonText: 'Appliquer',
        biCashButtonTextChoose: 'Choose',
        biCashButtonTextApplied: 'Applied',
        biCashLinkText: 'En savoir plus',
        rougeBadge: 'EXCLUSIVITÉ ROUGE',
        biCashValueOff: `${vars[0]} off`,
        biCashUpToOff: `Up to ${vars[0]} off`,
        biCashForPoints: `for ${vars[0]} points`,
        biCashTwoPromotionsPrefix: `${vars[0]} points = `,
        biCashTwoPromotionsSuffix: `${vars[0]} off`,
        ctaApplied: 'Applied',
        ctaRemove: 'Remove',
        biCashPoints: 'points',
        biCashOff: 'off',
        biCashUpTo: 'Up to',
        biCashFor: 'for',

        // BEP-522 error modal strings
        errorTitle: 'Error',
        okButtonText: 'OK',
        emptyBasketError: 'Merchandise, excluding gift cards, must be included in your order to qualify for this offer.',
        insufficientBasketWarning: `You have ${vars[0]} remaining on the Rouge Reward. Rouge Reward is one-time use only and expires within 90 days of redemption. If you wish to use the full value, add more items to your basket or remove the Rouge Reward and save for a future purchase.`
    };

    return resources[label];
}
